import React, { ReactNode } from 'react';
import classNames from 'classnames';

export type TableProps = {
    cols: any;
    children: ReactNode;
};

export type TableRowProps = {
    customClass?: string;
    children: ReactNode;
};

export type TableCellProps = {
    customClass?: string;
    children: ReactNode;
};

export const Table = ({ cols, children }: TableProps) => 
    <table className="gx-table">
        <thead className="gx-table__head">
            <tr className="gx-table__row">
                {cols.map((col, index) => 
                    <th key={`th_${index}`} className="gx-table__field">
                        <div className="gx-table__cell">{col}</div>
                    </th>
                )}
            </tr>
        </thead>
        <tbody className="gx-table__body">{children}</tbody>
    </table>;


export const TableRow = ({ customClass, children }: TableRowProps) => 
    <tr className={classNames('gx-table__row', customClass)}>{children}</tr>;

export const TableCell = ({ customClass, children }: TableCellProps) => 
    <td className={classNames('gx-table__field', customClass)}>
        <div className="gx-table__cell">
            {children}
        </div>
    </td>;

